import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'How to Ship Skis & Snowboards – Pack and Label Winter Gear | ShipSkis',
  description:
    'Learn how to pack and label your skis or snowboard for safe, stress-free shipping. ' +
    'Follow these simple steps from ShipSkis to prepare your gear for travel.',
  alternates: {
    canonical: 'https://www.shipskis.com/pack',
  },
}

export default metadata
